import React, { Component } from 'react'
import DataTable from '../../../components/Table/DataTable';
import Button from '../../../components/CustomButtons/Button';
import { Remove, Add } from '@material-ui/icons';
import { Tooltip, Fab } from '@material-ui/core';
import PickEmailDialog from './PickEmailDialog';
import SmallModal from '../../../components/Modal/SmallModal';
import Api from '../../../api/Api.js';
import ReportEndpoints from '../../../api/ReportEndpoints';

class Recipients extends Component {

    state = {
        addDialogOpen: false,
        removeDialogOpen: false,
        emailToRemove: { id: 0, title: '' }
    }

    render() {

        const { report_id } = this.props;

        console.log(this.props.emails);

        if (this.props.admin) {
            return [
                <DataTable
                    key="data"
                    title={"Emailed Report Recipients"}
                    data={this.props.emails.map(email =>
                        [
                            email,
                            <Tooltip title="Remove Email" placement="top">
                                <Button
                                    round
                                    justIcon
                                    color="danger"
                                    onClick={() => this.setState({ removeDialogOpen: true, emailToRemove: { id: email, title: email } })}
                                >
                                    <Remove fontSize="large" />
                                </Button>
                            </Tooltip>
                        ])}
                    columns={[
                        {
                            name: "Email Address",
                            options: {
                                filter: true,
                                sort: true,
                            }
                        },
                        {
                            name: 'Remove',
                            options: {
                                filter: false,
                                sort: false,
                                download: false,
                                print: false
                            }
                        }
                    ]}
                />,
                <Fab
                    key="fab"
                    style={{ float: 'right' }}
                    color="primary"
                    variant="extended"
                    onClick={() => this.setState({ addDialogOpen: true })}
                >
                    Add Recipient <Add />
                </Fab>,
                <PickEmailDialog
                    key="addDialog"
                    isOpen={this.state.addDialogOpen}
                    close={() => this.setState({ addDialogOpen: false })}
                    exclude={this.props.emails}
                    submit={(email_id) => {
                        Api.get(ReportEndpoints.addEmail, { email_id, report_id })
                        .then(({ data }) => {
                            this.props.added(data);
                            this.setState({ addDialogOpen: false });
                        })
                        .catch((e) => {
                            console.error(e);
                        })
                    }}
                />,
                <SmallModal
                    key="areYouSureRemove"
                    isOpen={this.state.removeDialogOpen}
                    accept={() => {
                        Api.get(ReportEndpoints.removeEmail, { email_id: this.state.emailToRemove.id, report_id })
                            .then(({ data }) => {
                                this.props.removed(this.state.emailToRemove.id);
                                this.setState({ removeDialogOpen: false });
                            })
                            .catch((e) => {
                                console.error(e);
                            })
                    }}
                    close={() => this.setState({ removeDialogOpen: false })}>
                    Are you sure you want to remove <span style={{ color: 'var(--primary)' }}>{this.state.emailToRemove.title}</span> from the list of recipients?
                </SmallModal>
            ];
        } else {
            return (
                <DataTable
                    title={"Emailed Report Recipients"}
                    data={this.props.emails.map(email => [email])}
                    columns={[{
                        name: "Email Address",
                        options: {
                            filter: true,
                            sort: true,
                        }
                    }]}
                />
            );
        }
    }
}

export default Recipients